var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElitePlan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.875 14.75C23.2119 14.75 21.7616 15.3575 20.75 16.3588V13.25H22.25C22.4489 13.25 22.6397 13.171 22.7803 13.0303C22.921 12.8897 23 12.6989 23 12.5C23 12.3011 22.921 12.1103 22.7803 11.9697C22.6397 11.829 22.4489 11.75 22.25 11.75H20.75V10.25C20.75 10.0511 20.671 9.86032 20.5303 9.71967C20.3897 9.57902 20.1989 9.5 20 9.5C19.8011 9.5 19.6103 9.57902 19.4697 9.71967C19.329 9.86032 19.25 10.0511 19.25 10.25V11.75H17.75C17.5511 11.75 17.3603 11.829 17.2197 11.9697C17.079 12.1103 17 12.3011 17 12.5C17 12.6989 17.079 12.8897 17.2197 13.0303C17.3603 13.171 17.5511 13.25 17.75 13.25H19.25V16.3588C18.2384 15.3575 16.7881 14.75 15.125 14.75C13.6337 14.7517 12.204 15.3449 11.1494 16.3994C10.0949 17.454 9.50174 18.8837 9.5 20.375C9.5 23.1744 10.8631 24.9547 12.0059 25.955C12.6065 26.4784 13.2778 26.9145 14 27.2506V29C14 29.3978 14.158 29.7794 14.4393 30.0607C14.7206 30.342 15.1022 30.5 15.5 30.5H24.5C24.8978 30.5 25.2794 30.342 25.5607 30.0607C25.842 29.7794 26 29.3978 26 29V27.2506C26.7222 26.9145 27.3935 26.4784 27.9941 25.955C29.1369 24.9547 30.5 23.1744 30.5 20.375C30.4983 18.8837 29.9051 17.454 28.8506 16.3994C27.796 15.3449 26.3663 14.7517 24.875 14.75ZM25.0128 26.0384C24.8635 26.0882 24.7336 26.1837 24.6415 26.3114C24.5495 26.4391 24.5 26.5926 24.5 26.75V29H15.5V26.75C15.5 26.5926 15.4505 26.4391 15.3585 26.3114C15.2664 26.1837 15.1365 26.0882 14.9872 26.0384C14.9469 26.0253 11 24.6594 11 20.375C11.0012 19.2814 11.4362 18.2329 12.2096 17.4596C12.9829 16.6862 14.0314 16.2512 15.125 16.25C17.5156 16.25 19.25 17.8269 19.25 20V26C19.25 26.1989 19.329 26.3897 19.4697 26.5303C19.6103 26.671 19.8011 26.75 20 26.75C20.1989 26.75 20.3897 26.671 20.5303 26.5303C20.671 26.3897 20.75 26.1989 20.75 26V20C20.75 17.8269 22.4844 16.25 24.875 16.25C25.9686 16.2512 27.0171 16.6862 27.7904 17.4596C28.5638 18.2329 28.9988 19.2814 29 20.375C29 24.6313 25.1731 25.9841 25.0128 26.0384Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElitePlan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/elite-plan.8af5217c21b4e026c08ac7df6305c12a.svg";